export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '8f7c3731-d05a-411a-9f77-34fefdf91b76';
export const MODAL_CLOSE_SEC = 2.5;
